<template>
  <v-container v-if="currentUser && currentUser.state !== 'STAFF'">
    <v-app-bar app color="secondary" dark dense>
      <v-toolbar-title>
        {{ $t("nav.user.auditPeriods") }}
      </v-toolbar-title>
    </v-app-bar>

    <v-card>
      <v-simple-table>
        <template #default>
          <thead>
            <tr>
              <th>{{ $t("user.auditPeriods.year") }}</th>
              <th>{{ $t("user.auditPeriods.funds") }}</th>
              <th width="1%"></th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="auditPeriod in oldAuditPeriods" :key="auditPeriod.id">
              <td>
                {{ auditPeriod.year }}
              </td>

              <td>
                {{ auditPeriod.funds.length }}
              </td>

              <td width="1%">
                <v-btn :to="{ name: 'userAuditPeriod', params: { id: auditPeriod.id } }" color="secondary" icon>
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </v-container>
</template>

<script>
import { propEq, reject } from "ramda";
import AuditPeriodsQuery from "@/gql/queries/AuditPeriodsQuery.gql";
import sortAuditPeriodsDesc from "@/utils/sortAuditPeriodsDesc";

const rejectCurrentAuditPeriod = reject(propEq("year", new Date().getFullYear()));

export default {
  data() {
    return {
      currentUser: null,
    };
  },

  computed: {
    oldAuditPeriods() {
      return sortAuditPeriodsDesc(rejectCurrentAuditPeriod(this.currentUser.auditPeriods));
    },
  },

  apollo: {
    currentUser: {
      query: AuditPeriodsQuery,
      fetchPolicy: "cache-and-network",
    },
  },
};
</script>
